module.exports = __webpack_public_path__ + "static/img/icon-logo-1@2x.94b4525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-logo-1@2x.png
// module id = qWi/
// module chunks = 9